import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getListDocFormStart,
  getListDocFormSuccess,
  getListDocFormFailed,
} from "../redux/getDocForm";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { SCREEN } from "helper/roleChecker/Screens";
import { formSearchSelectorDataSelector } from "../redux/selector";
import { omit } from "lodash";
import { getListDocFormApi } from "core/http/service/internalDocument";

function* getListDocFormWork() {
  const { offset, limit } = yield select(
    controlInfinitiveScrollSelector("docForm")
  );
  const form = yield select(formSearchSelectorDataSelector);
  const searchValue = omit(form, [
    "approvedStatusName",
    "categoryName",
    "departmentName",
    "levelName",
    "isSearching",
  ]);

  const params = { offset, limit, ...searchValue };
  try {
    const res = yield call(getListDocFormApi, {
      params,
      screenCode: SCREEN.IP_012,
    });
    yield put({
      type: getListDocFormSuccess.type,
      payload: {
        data: res.data,
        categoryName: res.categoryName,
        totalRecords: res.totalRecords,
      },
    });
  } catch (error: any) {
    yield put({
      type: getListDocFormFailed.type,
    });
  }
}

function* watchGetListDocForm() {
  yield takeLatest(getListDocFormStart.type, getListDocFormWork);
}

export default function* getListDocFormSaga() {
  yield all([watchGetListDocForm()]);
}
